import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@client/toolkit';
import { Transition } from '@headlessui/react';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { AppStatus, logout, selectAppStatus } from '../../redux';

import BackgroundImg from '../../assets/images/bg-exio.jpg';
import Logo from '../../assets/images/logo_exio.svg';

export function AppError() {
  const { t } = useTranslation('app', { useSuspense: false });
  const appStatus = useAppSelector(selectAppStatus);
  const dispatch = useAppDispatch();

  const handleSelectLogout = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  return (
    <Transition
      show={appStatus === AppStatus.ERROR || appStatus === AppStatus.INIT_ERROR}
      enter="transition-opacity duration-75"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className="fixed flex flex-col top-0 left-0 right-0 h-full w-full bg-cover bg-center "
        style={{ backgroundImage: `url(${BackgroundImg})`, filter: 'brightness(0.2)' }}
      />
      <div className="fixed flex top-0 left-0 right-0 h-full w-full bg-cover bg-center items-center justify-center">
        <div className="bg-[#151411] border border-border text-white p-8 rounded-lg shadow-lg max-w-md text-center">
          <div className="mb-8">
            <img className="mx-auto mb-2" src={Logo} alt="logo" width={100} />
            <h1 className="text-3xl">{t('appError.title')}</h1>
          </div>

          <div className="border border-border bg-surface-base rounded-md p-3 pb-4 text-sm bg-black bg-opacity-30 mb-8 w-[388px]">
            <h2 className="text-lg mb-1 pt-4">{t('appError.errorMessage')}</h2>
            <p className="text-gray-300 pb-8">
              {t('appError.errorDescription1')}
              <br />
              {t('appError.errorDescription2')}
            </p>
          </div>

          <Button className="bg-primary-base rounded-md mb-16" onClick={handleSelectLogout}>
            {t('appError.backToLogin')}
          </Button>
        </div>
      </div>
    </Transition>
  );
}

export default AppError;
